import { render, staticRenderFns } from "./searchBoxDetail.vue?vue&type=template&id=25de5886&scoped=true"
import script from "./searchBoxDetail.vue?vue&type=script&lang=js"
export * from "./searchBoxDetail.vue?vue&type=script&lang=js"
import style0 from "./searchBoxDetail.vue?vue&type=style&index=0&id=25de5886&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25de5886",
  null
  
)

export default component.exports